<template>
  <div class="menu-wrapper">
    <el-submenu
      v-if="!item.hidden"
      :index="item.name || item.path"
      :key="item.name || item.path"
      v-debounce
      @click.native.capture="preventParentMenuClick"
    >
      <template slot="title">
        <svg-icon v-if="isCollapse && item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
        <span v-if="item.meta&&item.meta.title" slot="title">{{ $t(item.meta.title) }}</span>
      </template>

      <template v-for="child in visibleChildren" v-if="!child.hidden">
        <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :item="child"
                      :key="child.path"></sidebar-item>
        <a v-else-if="isExternal(child.path)" v-bind:href="child.path" target="_blank" :key="child.name || child.path">
          <el-menu-item :index="child.path">
            <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
            <span v-if="child.meta&&child.meta.title" slot="title">{{ $t(child.meta.title) }}</span>
          </el-menu-item>
        </a>
        <router-link
          v-else
          :to="resolvePath(child)"
        >
          <el-menu-item :index="resolvePath(child)" v-debounce @click="handleMenuClick(child.name)">
            <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
            <span v-if="child.meta&&child.meta.title" slot="title">{{ $t(child.meta.title) }}</span>
          </el-menu-item>
        </router-link>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { clearScrollPositions, setNavigationSource } from '@/utils/pageNavigation'

export default {
  name: 'SidebarItem',
  props: {
    item: {
      required: true,
      type: Object
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    },
    visibleChildren() {
      return Array.isArray(this.item.children)
        ? this.item.children.filter(child => !child.hidden)
        : []
    }
  },
  methods: {
    handleMenuClick(routeName) {
      clearScrollPositions()
      if (routeName !== this.$route.name) setNavigationSource('menu')
      this.$store.commit('RESET_PAGE_CACHE', routeName)
    },
    preventParentMenuClick(event) {
      if (event.target.closest('.el-submenu__title')) {
        event.stopPropagation()
      }
    },
    isExternal(path) {
      return typeof path === 'string' && path.startsWith('http')
    },
    resolvePath(child) {
      if (!child || !child.path) return this.item.path
      if (child.path.startsWith('/')) return child.path
      return `${this.item.path}/${child.path}`
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue